import styled from 'styled-components';

import { Nav } from 'reactstrap';

const StyledNavTabs = styled(Nav)`
  border-bottom: none !important;
  margin: 0;
  margin-bottom: 16px;
  .nav-item {
    margin-bottom: -2px;
    margin-right: 34px;
  }
`;

export default StyledNavTabs;
